import { DatePipe } from '@angular/common';
import { ArrayLimitToPipe } from '../../filters/array-limit-to.pipe';
import { StartFromPipe } from '../../filters/start-from.pipe';
import { TranslatePipe } from '../../filters/translate.pipe';
import { ItemNoContentComponent } from '../../components/item-no-content/item-no-content.component';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import ServiceRestServices from '../../services/service-rest.service';
import Config from '../../utils/config.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import AngularHelperService from '../../services/angular-helper.service';
import { Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
	standalone: true,
	selector: 'table-invoices',
	templateUrl: './table-invoices.component.html',
	imports: [
		CommonModule, DatePipe, ArrayLimitToPipe, StartFromPipe, 
		TranslatePipe, ItemNoContentComponent, LoaderOverlayComponent, FormsModule
	]
})
export class TableInvoicesComponent implements OnInit, OnDestroy {
	private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);
	private config: Config = inject(Config);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
		
	@Input() invoices: any;
	@Output() invoicesChange: EventEmitter<any> = new EventEmitter<any>();
	@Input() pageSize: any | undefined;
	@Input() currentPage: any | undefined;
	@Output() currentPageChange: EventEmitter<any> = new EventEmitter<any>(); // TODO ANGULAR_2: fix calling event emitter
	
	vm: any = undefined;
	broadcastSubscriptions: Array<Subscription> = [];
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.pageSize = this.vm.pageSize || 10;
		this.vm.currentPage = this.vm.currentPage || 0;
		this.vm.endReached = false;
		this.vm.loading = true;
		this.loadInvoices(true, true);
		
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(this, "loadMorePages", () => {
				if (!this.vm.endReached) {
					this.loadInvoices();
				}
			})
		);
		
		this.vm.downloadInvoice = this.downloadInvoice;
	}
	
	ngOnDestroy() {
		for (var b = 0; b < this.broadcastSubscriptions.length; b++) {
			this.broadcastSubscriptions[b].unsubscribe();
		}
	}
	
	downloadInvoice(id) {
		if (typeof id === 'undefined') return;
		var url: any = this.config.getRestUrl() + 'rest/invoice/' + id + '/invoice.pdf';
		window.open(url, '_self');
	}
	
	loadInvoices(isInitial?, hasLoader?) {
		if (isInitial) {
			this.vm.endReached = false;
		} else if (this.vm.endReached) {
			this.vm.loading = false;
			return;
		}
		this.serviceRestServices.getInvoices({
			pageSize: this.vm.pageSize * 2,
			start: (!isInitial && this.vm.invoices) ? this.vm.invoices.length : 0
		}, (invoices) => {
			if (invoices && invoices.length < this.vm.pageSize * 2) {
				this.vm.endReached = true;
			}
			if (isInitial) this.vm.currentPage = 0;
			if (hasLoader) {
				this.angularHelperService.createTimer(() => {
					this.vm.loading = false;
					this.vm.invoices = isInitial ? invoices : this.vm.invoices.concat(invoices);
					this.invoicesChange.emit(this.vm.invoices);
				}, this.config.getOtherConfig().LOADER_TIMEOUT_DELAY);
			} else {
				this.vm.invoices = isInitial ? invoices : this.vm.invoices.concat(invoices);
				this.invoicesChange.emit(this.vm.invoices);
			}
		});
	}
	
}